import RichText from '@/components/RichText';
import Image from 'next/image';
import { cls } from '@/utils/cls';
import styles from './CalloutBox.module.scss';
import type { CalloutBoxProps as Props } from './types';
export default function CalloutBox({
  logo,
  title,
  bodyText,
  showTitle = true,
  showBodyText = true,
  showAccent = true,
  titleColor,
  bodyTextColor,
  backgroundColor,
  accentColor,
  extendStyles
}: Props) {
  const _className = cls(styles.root, !showAccent && styles.noAccent, extendStyles);
  const logoImage = logo?.value?.data?.image;
  const logoName = logo?.value?.data?.name;
  const customStyles = {
    ...(backgroundColor && {
      '--background-color': backgroundColor
    }),
    ...(titleColor && {
      '--title-color': titleColor
    }),
    ...(bodyTextColor && {
      '--body-text-color': bodyTextColor
    }),
    ...(accentColor && {
      '--accent-color': accentColor
    })
  } as React.CSSProperties;
  return <div className={cls(_className, !showBodyText && styles.centered)} style={customStyles} data-sentry-component="CalloutBox" data-sentry-source-file="CalloutBox.tsx">
			{logoImage && <div className={styles.logoWrapper}>
					<Image src={logoImage} alt={logoName || ''} width={23} height={27} className={styles.logo} role={logoName ? undefined : 'presentation'} unoptimized />
				</div>}
			<div className={styles.contentWrapper}>
				{showTitle && <RichText className={styles.title} text={title} />}
				{showBodyText && <RichText className={styles.bodyText} text={bodyText} />}
			</div>
		</div>;
}